  <template>
    <div class="listagem">
      <el-row v-if="titulo" :style="'background:' + estilo.aplicacao.corPrimariaAplicacao + '1f'" class="listagem-header">
      <el-col :span="20">
        <span class="titulo-listagem">{{ titulo }}</span>
      </el-col>
        <el-col :span="4">
          <svg-icone v-if="icon" class="align-icon" :icone="icon"></svg-icone>
          <span class="text-header">{{texto}}</span>
        </el-col>
      </el-row>
      <el-table
        :data="listagemData"
        :row-class-name="'status-row'"
        style="width: 100%"
        @row-click="clickRow"
      >
        <el-table-column
          style="width: 120%"
          v-for="(column, index) in columns"
          :key="index"
          :width="column.width"
          :label="column.header ? column.header.label : null"
        >
          <template slot-scope="scope">
            <component
              class="alinhamento"
              :is="column.component"
              v-if="column.component"
              :column="column"
              :row="scope.row"
            />
            <template
              v-if="!column.component"
              :class-name="`item-${column.field}`"
            >
              {{ scope.row[column.field] || '-' }}
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </template>
<script>
import { mapGetters } from 'vuex'
import InlineSvg from 'vue-inline-svg'
export default {
  name: 'Listagem',
  props: {
    columns: {
      type: Array,
      required: true
    },
    listagemData: {
      type: Array,
      required: true
    },
    titulo: {
      type: String
    },
    texto: {
      type: String
    },
    icon: {
      type: String
    },
    icone: {
      type: String
    },
    clickRow: {
      type: Function,
      default: (row) => {
      }
    }
  },
  components: {
    InlineSvg
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo'])
  }
}
</script>
<style>
@media print {
  .alinhamento:nth-child(2){
    float: right;
    position: relative;
    right: 20px;
  }
}
</style>
